var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"potato-sidebar"},_vm._l((_vm.options),function(option,index){return _c('button',{key:index,staticClass:"sidebar-button"},[_vm._v("\n    "+_vm._s(option.name)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }